var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.028,
    height: 12,
    viewBox: "0 0 12.028 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time",
    transform: "translate(0 -0.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30981",
    "data-name": "Path 30981",
    d: "M6.014.333a5.8,5.8,0,0,1,4.253,1.761,5.779,5.779,0,0,1,1.761,4.239,5.779,5.779,0,0,1-1.761,4.239,5.8,5.8,0,0,1-4.253,1.761,5.8,5.8,0,0,1-4.253-1.761A5.779,5.779,0,0,1,0,6.333,5.779,5.779,0,0,1,1.761,2.094,5.8,5.8,0,0,1,6.014.333Zm0,10.817A4.626,4.626,0,0,0,9.408,9.742a4.643,4.643,0,0,0,1.408-3.408A4.643,4.643,0,0,0,9.408,2.925,4.626,4.626,0,0,0,6.014,1.516,4.626,4.626,0,0,0,2.62,2.925,4.643,4.643,0,0,0,1.211,6.333,4.643,4.643,0,0,0,2.62,9.742,4.626,4.626,0,0,0,6.014,11.15Zm.3-7.831V6.474l2.7,1.606-.451.761L5.408,6.925V3.319Z",
    transform: "translate(0 0)",
    fill: "#a7a7a7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.c24d6ad0e3c80a10200da8a37f0be8dc.svg";
export { ForwardRef as ReactComponent };